const MobileNavigation = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
		_settings.$burger = document.querySelector(_settings.burger);
		_settings.$searchLink = document.querySelector(_settings.searchLink);
		_settings.$search = document.querySelector(_settings.search);
		_settings.$searchClose = document.querySelector(_settings.searchClose);
	}

	function bindEvents() {
		window.addEventListener("resize", resize);
		_settings.$burger.addEventListener("click", toggleMobileNavigation);
		_settings.$searchLink.addEventListener("click", toggleSearchModal);
		_settings.$searchClose.addEventListener("click", closeSearchModal);
	}

	function resize() {
		_settings.$el.classList.remove(_settings.openedClass);
	}

	function toggleMobileNavigation() {
		_settings.$el.classList.toggle(_settings.openedClass);
	}

	function toggleSearchModal(e) {
		if (window.innerWidth >= 768) {
			e.preventDefault();
			_settings.$search.classList.toggle(_settings.searchShowClass);
		}
	}

	function closeSearchModal() {
		_settings.$search.classList.remove(_settings.searchShowClass);
	}

	function init() {
		cacheDom();
		bindEvents();

		return _self;
	}

	return init();
};

export { MobileNavigation };
